<template>
  <div class="waiting-list">
    <div class="waiting-title">
      <div class="waiting-title-left">
        <span>待答名单({{ studentList.length || 0 }})</span>
        <a-tooltip
          v-if="environment === 'offlineElectron' && !isNoBindDTQ"
          placement="bottom"
          :get-popup-container="triggerNode => triggerNode.parentNode"
        >
          <template slot="title">
            <span>只显示已绑定答题器学生</span>
          </template>
          <div :class="['clicker-filtter', clickerFiltter ? 'active' : 'active']" @click="changeFiltter" />
        </a-tooltip>
      </div>
    </div>
    <div ref="waitingContent" class="waiting-content">
      <template v-if="$_.isEmpty(studentList)">
        <div class="empty-box">
          <img class="empty-img" :src="require('@/assets/test/empty.png')" alt="" width="130" height="118" />
          <div class="empty-message">当前班级暂无学生~</div>
          <div class="empty-remark">如需使用点名功能请导入学生名单</div>
        </div>
      </template>
      <template v-else>
        <!-- 小组排序模式 -->
        <template v-if="currentSortType === 3">
          <template v-for="group in groupedStudentList">
            <!-- 分组 header -->
            <div :key="'group-' + group.id" class="group-header" @click="toggleGroup(group.id)">
              <div class="group-header-left">
                <img
                  class="group-collapse-icon"
                  :style="{ transform: collapsedGroups[group.id] ? 'rotate(180deg)' : 'rotate(0deg)' }"
                  src="@/assets/common/arrow_bottom.png"
                  alt=""
                />
                <span class="group-header-name">{{ group.name }}({{ group.students.length }})</span>
                <img
                  src="@/assets/common/group_edit_icon.png"
                  alt=""
                  style="height: 14px"
                  @click.stop="handleEditGroup(group)"
                />
              </div>
              <div
                v-if="getGroupAvgScore(group) !== null"
                class="group-avg-score"
                :class="getScoreColor(getGroupAvgScoreRate(group))"
              >
                {{ getGroupAvgScore(group).toFixed(2) }}分
              </div>
            </div>
            <!-- 分组学生列表 -->
            <template v-if="!collapsedGroups[group.id]">
              <template v-for="item in group.students">
                <div
                  v-if="!clickerFiltter || item.isBindAnswerDevice"
                  :id="item.id"
                  :key="item.id"
                  :class="[
                    'waiting-item',
                    activeAnswer && activeAnswer.id === item.id ? 'active' : '',
                    answerState === 'respond' ||
                    (testType === 'written' && answerState === 'success' && !answerData[item.id])
                      ? 'respond'
                      : ''
                  ]"
                  @click="changeAnswer(item)"
                >
                  <div class="waiting-item-left">
                    <div class="waiting-item-name" style="margin-left: 8px">
                      {{ item['realName'] || item['name'] || item['loginAccount'] }}
                      <!-- 答题器 icon：已绑定时显示，录音中显示灰色且不可点击 -->
                      <img
                        v-if="item.isBindAnswerDevice"
                        :src="
                          answerState === 'respond'
                            ? require('@/assets/test/clicker_unactive.png')
                            : require('@/assets/test/clicker_active.png')
                        "
                        alt=""
                        width="12"
                        height="12"
                        :class="['clicker-inline-icon', answerState === 'respond' ? 'disabled' : '']"
                        @click.stop="handleClickerIconClick(item)"
                      />
                      <!-- 无答题器录音 icon，跟在名字后面（仅在无任何学生绑定答题器时显示） -->
                      <img
                        v-if="!item.isBindAnswerDevice && disableTeam"
                        :src="
                          answerState === 'respond'
                            ? require('@/assets/common/record_icon_gray.png')
                            : require('@/assets/common/record_icon.png')
                        "
                        alt=""
                        width="16"
                        height="16"
                        :class="['record-inline-icon', answerState === 'respond' ? 'disabled' : '']"
                        @click.stop="selectAndRecord(item)"
                      />
                    </div>
                  </div>
                  <!-- 作答状态/结果区域 -->
                  <template v-if="playType === 'SINGLE'">
                    <template
                      v-if="
                        answerState === 'respond' ||
                        (testType === 'written' && answerState === 'success' && !answerData[item.id])
                      "
                    >
                      <div
                        v-if="activeAnswer && activeAnswer.id === item.id"
                        class="waiting-item-content"
                        @click="startRespond"
                      >
                        <img class="wait-record-icon recording" :src="testTypeWaitEnum[testType]?.respondIcon" alt="" />
                        <div class="waiting-item-text recording">{{ testTypeWaitEnum[testType]?.respondText }}</div>
                      </div>
                      <template v-else-if="answerData[item.id]">
                        <div
                          v-if="testType !== 'written'"
                          class="waiting-item-answer"
                          @click.stop="checkAnswer(answerData[item.id], item)"
                        >
                          <div class="waiting-item-answer-left">
                            <div
                              :class="[
                                'answer-score',
                                answerData[item.id].result.scoreRate < 60
                                  ? 'col-FF3C30'
                                  : answerData[item.id].result.scoreRate < 85
                                    ? 'col-FFA516'
                                    : 'col-1DC060'
                              ]"
                            >
                              <template v-if="$store.getters.isGradeSchool">
                                <img
                                  :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))"
                                  alt=""
                                  class="score-img"
                                />
                              </template>
                              <template v-else>{{ Number(answerData[item.id].result.overall).toFixed(2) }}分</template>
                            </div>
                            <div class="answer-star">
                              <template v-for="idx in 5">
                                <img
                                  :key="idx"
                                  class="answer-star-img"
                                  :src="
                                    idx <= fetchStarNum(answerData[item.id].result.scoreRate)
                                      ? require('@/assets/common/star_highlight.png')
                                      : require('@/assets/common/star_grey.png')
                                  "
                                  alt=""
                                />
                              </template>
                            </div>
                          </div>
                          <img
                            class="arrow-right-icon"
                            :src="require('@/assets/common/small_arrow_right_gray.png')"
                            alt=""
                          />
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="answerData[item.id]">
                        <div
                          v-if="testType !== 'written'"
                          class="waiting-item-answer"
                          @click.stop="checkAnswer(answerData[item.id], item)"
                        >
                          <div class="waiting-item-answer-left">
                            <div
                              :class="[
                                'answer-score',
                                answerData[item.id].result.scoreRate < 60
                                  ? 'col-FF3C30'
                                  : answerData[item.id].result.scoreRate < 85
                                    ? 'col-FFA516'
                                    : 'col-1DC060'
                              ]"
                            >
                              <template v-if="$store.getters.isGradeSchool">
                                <img
                                  :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))"
                                  alt=""
                                  class="score-img"
                                />
                              </template>
                              <template v-else>{{ Number(answerData[item.id].result.overall).toFixed(2) }}分</template>
                            </div>
                            <div class="answer-star">
                              <template v-for="idx in 5">
                                <img
                                  :key="idx"
                                  class="answer-star-img"
                                  :src="
                                    idx <= fetchStarNum(answerData[item.id].result.scoreRate)
                                      ? require('@/assets/common/star_highlight.png')
                                      : require('@/assets/common/star_grey.png')
                                  "
                                  alt=""
                                />
                              </template>
                            </div>
                          </div>
                          <img
                            class="arrow-right-icon"
                            :src="require('@/assets/common/small_arrow_right_gray.png')"
                            alt=""
                          />
                        </div>
                      </template>
                      <div
                        v-else-if="activeAnswer && activeAnswer.id === item.id"
                        class="waiting-item-content"
                        @click.stop="startRespond"
                      >
                        <img
                          class="wait-record-icon"
                          :src="
                            activeAnswer.isBindAnswerDevice
                              ? testTypeWaitEnum[testType]?.waitIcon
                              : testTypeWaitEnum[testType]?.disabledWaitIcon
                          "
                          alt=""
                        />
                        <div class="waiting-item-text">{{ testTypeWaitEnum[testType]?.waitText }}</div>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div v-if="item.answerState !== 'success' && item.isBindAnswerDevice" class="waiting-item-state">
                      <template v-if="item.answerState === 'wait' && item.isBindAnswerDevice">
                        <img class="item-state-icon" :src="require('@/assets/common/record.png')" alt="" />
                        <div class="item-state-text">等待录音</div>
                      </template>
                      <template v-if="item.answerState === 'recording' && item.isBindAnswerDevice">
                        <img class="item-state-icon" :src="require('@/assets/common/record.gif')" alt="" />
                        <div class="item-state-text">录音中</div>
                      </template>
                      <template v-if="item.answerState === 'evaluating' && item.isBindAnswerDevice">
                        <div class="evaluating-icon-box">
                          <img class="item-state-icon" :src="require('@/assets/common/loading-white-gif.gif')" alt="" />
                        </div>
                        <div class="item-state-text">评测中</div>
                      </template>
                    </div>
                    <div
                      v-if="item.answerState === 'success' && item.isBindAnswerDevice"
                      class="waiting-item-answer"
                      @click.stop="checkAnswer(answerData[item.id], item)"
                    >
                      <div class="waiting-item-answer-left">
                        <div
                          :class="[
                            'answer-score',
                            answerData[item.id]?.result?.scoreRate < 60
                              ? 'col-FF3C30'
                              : answerData[item.id]?.result?.scoreRate < 85
                                ? 'col-FFA516'
                                : 'col-1DC060'
                          ]"
                        >
                          <template v-if="$store.getters.isGradeSchool">
                            <img
                              :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))"
                              alt=""
                              class="score-img"
                            />
                          </template>
                          <template v-else>{{ Number(answerData[item.id]?.result?.overall).toFixed(2) }}分</template>
                        </div>
                        <div class="answer-star">
                          <template v-for="idx in 5">
                            <img
                              :key="idx"
                              class="answer-star-img"
                              :src="
                                idx <= fetchStarNum(answerData[item.id]?.result?.scoreRate)
                                  ? require('@/assets/common/star_highlight.png')
                                  : require('@/assets/common/star_grey.png')
                              "
                              alt=""
                            />
                          </template>
                        </div>
                      </div>
                      <img
                        class="arrow-right-icon"
                        :src="require('@/assets/common/small_arrow_right_gray.png')"
                        alt=""
                      />
                    </div>
                  </template>
                </div>
              </template>
            </template>
          </template>
        </template>

        <!-- 序号/分数排序模式 -->
        <template v-else>
          <template v-for="item in sortStudentList">
            <template v-if="playType === 'SINGLE'">
              <div
                v-if="!clickerFiltter || item.isBindAnswerDevice"
                :id="item.id"
                :key="item.id"
                :class="[
                  'waiting-item',
                  activeAnswer && activeAnswer.id === item.id ? 'active' : '',
                  answerState === 'respond' ||
                  (testType === 'written' && answerState === 'success' && !answerData[item.id])
                    ? 'respond'
                    : ''
                ]"
                @click="changeAnswer(item)"
              >
                <div class="waiting-item-left">
                  <!-- 置顶 icon -->
                  <span :class="['pin-icon', pinnedIds[item.id] ? 'pinned' : '']" @click.stop="togglePin(item)">
                    <img
                      :src="
                        pinnedIds[item.id]
                          ? require('@/assets/common/pin_to_top_cancel_icon.png')
                          : require('@/assets/common/pin_to_top_icon.png')
                      "
                      alt=""
                      width="16"
                      height="16"
                    />
                  </span>
                  <div class="waiting-item-name">
                    {{ item['realName'] || item['name'] || item['loginAccount'] }}
                    <!-- 答题器 icon：已绑定时显示，录音中显示灰色且不可点击 -->
                    <img
                      v-if="item.isBindAnswerDevice"
                      :src="
                        answerState === 'respond'
                          ? require('@/assets/test/clicker_unactive.png')
                          : require('@/assets/test/clicker_active.png')
                      "
                      alt=""
                      width="12"
                      height="12"
                      :class="['clicker-inline-icon', answerState === 'respond' ? 'disabled' : '']"
                      @click.stop="handleClickerIconClick(item)"
                    />
                    <!-- 无答题器录音 icon，跟在名字后面（仅在无任何学生绑定答题器时显示） -->
                    <img
                      v-if="!item.isBindAnswerDevice && disableTeam"
                      :src="
                        answerState === 'respond'
                          ? require('@/assets/common/record_icon_gray.png')
                          : require('@/assets/common/record_icon.png')
                      "
                      alt=""
                      width="16"
                      height="16"
                      :class="['record-inline-icon', answerState === 'respond' ? 'disabled' : '']"
                      @click.stop="selectAndRecord(item)"
                    />
                  </div>
                </div>
                <!--作答中-->
                <template
                  v-if="
                    answerState === 'respond' ||
                    (testType === 'written' && answerState === 'success' && !answerData[item.id])
                  "
                >
                  <!--选中的学生-->
                  <div
                    v-if="activeAnswer && activeAnswer.id === item.id"
                    class="waiting-item-content"
                    @click="startRespond"
                  >
                    <img class="wait-record-icon recording" :src="testTypeWaitEnum[testType]?.respondIcon" alt="" />
                    <div class="waiting-item-text recording">{{ testTypeWaitEnum[testType]?.respondText }}</div>
                  </div>

                  <!--未选中但有作答记录的学生-->
                  <template v-else-if="answerData[item.id]">
                    <div
                      v-if="testType === 'written'"
                      class="written-answer"
                      @click.stop="checkAnswer(answerData[item.id], item)"
                    >
                      <template v-if="answerData[item.id].accuracy <= 0">
                        <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.errorIcon" alt="" />
                        <span :class="['written-answer-text', testTypeWaitEnum[testType]?.errorColor]">
                          {{ testTypeWaitEnum[testType]?.errorText }}
                        </span>
                      </template>
                      <template v-else-if="answerData[item.id].accuracy < 100">
                        <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.inaccuracyIcon" alt="" />
                        <span :class="['written-answer-text', testTypeWaitEnum[testType]?.inaccuracyColor]">
                          {{ testTypeWaitEnum[testType]?.inaccuracyText }}
                        </span>
                      </template>
                      <template v-else>
                        <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.correctIcon" alt="" />
                        <span :class="['written-answer-text', testTypeWaitEnum[testType]?.correctColor]">
                          {{ testTypeWaitEnum[testType]?.correctText }}
                        </span>
                      </template>
                    </div>
                    <div v-else class="waiting-item-answer" @click.stop="checkAnswer(answerData[item.id], item)">
                      <div class="waiting-item-answer-left">
                        <div
                          :class="[
                            'answer-score',
                            answerData[item.id].result.scoreRate < 60
                              ? 'col-FF3C30'
                              : answerData[item.id].result.scoreRate < 85
                                ? 'col-FFA516'
                                : 'col-1DC060'
                          ]"
                        >
                          <template v-if="$store.getters.isGradeSchool">
                            <img
                              :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))"
                              alt=""
                              class="score-img"
                            />
                          </template>
                          <template v-else>{{ Number(answerData[item.id].result.overall).toFixed(2) }}分</template>
                        </div>
                        <div class="answer-star">
                          <template v-for="index in 5">
                            <img
                              :key="index"
                              class="answer-star-img"
                              :src="
                                index <= fetchStarNum(answerData[item.id].result.scoreRate)
                                  ? require('@/assets/common/star_highlight.png')
                                  : require('@/assets/common/star_grey.png')
                              "
                              alt=""
                            />
                          </template>
                        </div>
                      </div>
                      <img
                        class="arrow-right-icon"
                        :src="require('@/assets/common/small_arrow_right_gray.png')"
                        alt=""
                      />
                    </div>
                  </template>
                </template>
                <!--作答完成与等待作答-->
                <template v-else>
                  <!--有作答记录的学生-->
                  <template v-if="answerData[item.id]">
                    <div
                      v-if="testType === 'written'"
                      class="written-answer"
                      @click.stop="checkAnswer(answerData[item.id], item)"
                    >
                      <template v-if="answerData[item.id].accuracy <= 0">
                        <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.errorIcon" alt="" />
                        <span :class="['written-answer-text', testTypeWaitEnum[testType]?.errorColor]">
                          {{ answerData[item.id].noReply ? '未作答' : testTypeWaitEnum[testType]?.errorText }}
                        </span>
                      </template>
                      <template v-else-if="answerData[item.id].accuracy < 100">
                        <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.inaccuracyIcon" alt="" />
                        <span :class="['written-answer-text', testTypeWaitEnum[testType]?.inaccuracyColor]">
                          {{ testTypeWaitEnum[testType]?.inaccuracyText }}
                        </span>
                      </template>
                      <template v-else>
                        <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.correctIcon" alt="" />
                        <span :class="['written-answer-text', testTypeWaitEnum[testType]?.correctColor]">
                          {{ testTypeWaitEnum[testType]?.correctText }}
                        </span>
                      </template>
                    </div>
                    <div v-else class="waiting-item-answer" @click.stop="checkAnswer(answerData[item.id], item)">
                      <div class="waiting-item-answer-left">
                        <div
                          :class="[
                            'answer-score',
                            answerData[item.id].result.scoreRate < 60
                              ? 'col-FF3C30'
                              : answerData[item.id].result.scoreRate < 85
                                ? 'col-FFA516'
                                : 'col-1DC060'
                          ]"
                        >
                          <template v-if="$store.getters.isGradeSchool">
                            <img
                              :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))"
                              alt=""
                              class="score-img"
                            />
                          </template>
                          <template v-else>{{ Number(answerData[item.id].result.overall).toFixed(2) }}分</template>
                        </div>
                        <div class="answer-star">
                          <template v-for="index in 5">
                            <img
                              :key="index"
                              class="answer-star-img"
                              :src="
                                index <= fetchStarNum(answerData[item.id].result.scoreRate)
                                  ? require('@/assets/common/star_highlight.png')
                                  : require('@/assets/common/star_grey.png')
                              "
                              alt=""
                            />
                          </template>
                        </div>
                      </div>
                      <img
                        class="arrow-right-icon"
                        :src="require('@/assets/common/small_arrow_right_gray.png')"
                        alt=""
                      />
                    </div>
                  </template>
                  <!--选中但没有作答记录的学生-->
                  <div
                    v-else-if="activeAnswer && activeAnswer.id === item.id"
                    class="waiting-item-content"
                    @click.stop="startRespond"
                  >
                    <img
                      class="wait-record-icon"
                      :src="
                        activeAnswer.isBindAnswerDevice
                          ? testTypeWaitEnum[testType]?.waitIcon
                          : testTypeWaitEnum[testType]?.disabledWaitIcon
                      "
                      alt=""
                    />
                    <div class="waiting-item-text">{{ testTypeWaitEnum[testType]?.waitText }}</div>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div
                v-if="!clickerFiltter || item.isBindAnswerDevice"
                :key="item.id"
                :class="[
                  'waiting-item',
                  (item.answerState === 'wait' || item.answerState === 'evaluating') && item.isBindAnswerDevice
                    ? 'waiting-answer'
                    : item.answerState === 'recording' && item.isBindAnswerDevice
                      ? 'recording-answer'
                      : ''
                ]"
                @click="changeAnswer(item)"
              >
                <div class="waiting-item-left">
                  <!-- 置顶 icon -->
                  <span :class="['pin-icon', pinnedIds[item.id] ? 'pinned' : '']" @click.stop="togglePin(item)">
                    <img
                      :src="
                        pinnedIds[item.id]
                          ? require('@/assets/common/pin_to_top_cancel_icon.png')
                          : require('@/assets/common/pin_to_top_icon.png')
                      "
                      alt=""
                      width="16"
                      height="16"
                    />
                  </span>
                  <div class="waiting-item-name">
                    {{ item['realName'] || item['name'] || item['loginAccount'] }}
                    <!-- 答题器 icon：已绑定时显示，录音中显示灰色且不可点击 -->
                    <img
                      v-if="item.isBindAnswerDevice"
                      :src="
                        answerState === 'respond'
                          ? require('@/assets/test/clicker_unactive.png')
                          : require('@/assets/test/clicker_active.png')
                      "
                      alt=""
                      width="12"
                      height="12"
                      :class="['clicker-inline-icon', answerState === 'respond' ? 'disabled' : '']"
                      @click.stop="handleClickerIconClick(item)"
                    />
                    <!-- 无答题器录音 icon，跟在名字后面（仅在无任何学生绑定答题器时显示） -->
                    <img
                      v-if="!item.isBindAnswerDevice && disableTeam"
                      :src="
                        answerState === 'respond'
                          ? require('@/assets/common/record_icon_gray.png')
                          : require('@/assets/common/record_icon.png')
                      "
                      alt=""
                      width="16"
                      height="16"
                      :class="['record-inline-icon', answerState === 'respond' ? 'disabled' : '']"
                      @click.stop="selectAndRecord(item)"
                    />
                  </div>
                </div>
                <div v-if="item.answerState !== 'success' && item.isBindAnswerDevice" class="waiting-item-state">
                  <template v-if="item.answerState === 'wait' && item.isBindAnswerDevice">
                    <img class="item-state-icon" :src="require('@/assets/common/record.png')" alt="" />
                    <div class="item-state-text">等待录音</div>
                  </template>
                  <template v-if="item.answerState === 'recording' && item.isBindAnswerDevice">
                    <img class="item-state-icon" :src="require('@/assets/common/record.gif')" alt="" />
                    <div class="item-state-text">录音中</div>
                  </template>
                  <template v-if="item.answerState === 'evaluating' && item.isBindAnswerDevice">
                    <div class="evaluating-icon-box">
                      <img class="item-state-icon" :src="require('@/assets/common/loading-white-gif.gif')" alt="" />
                    </div>
                    <div class="item-state-text">评测中</div>
                  </template>
                </div>
                <div
                  v-if="item.answerState === 'success' && item.isBindAnswerDevice"
                  class="waiting-item-answer"
                  @click.stop="checkAnswer(answerData[item.id], item)"
                >
                  <div class="waiting-item-answer-left">
                    <div
                      :class="[
                        'answer-score',
                        answerData[item.id]?.result?.scoreRate < 60
                          ? 'col-FF3C30'
                          : answerData[item.id]?.result?.scoreRate < 85
                            ? 'col-FFA516'
                            : 'col-1DC060'
                      ]"
                    >
                      <template v-if="$store.getters.isGradeSchool">
                        <img :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))" alt="" class="score-img" />
                      </template>
                      <template v-else>{{ Number(answerData[item.id]?.result?.overall).toFixed(2) }}分</template>
                    </div>
                    <div class="answer-star">
                      <template v-for="index in 5">
                        <img
                          :key="index"
                          class="answer-star-img"
                          :src="
                            index <= fetchStarNum(answerData[item.id]?.result?.scoreRate)
                              ? require('@/assets/common/star_highlight.png')
                              : require('@/assets/common/star_grey.png')
                          "
                          alt=""
                        />
                      </template>
                    </div>
                  </div>
                  <img class="arrow-right-icon" :src="require('@/assets/common/small_arrow_right_gray.png')" alt="" />
                </div>
              </div>
            </template>
          </template>
        </template>
        <!-- end v-else (序号/分数排序) -->
      </template>
    </div>

    <!-- 底部排序 tab -->
    <div class="sort-tab-bar">
      <div class="sort-tab-group">
        <div :class="['sort-tab-item', currentSortType === 1 ? 'active' : '']" @click="onChangeSortType(1)">
          <img :src="require('@/assets/common/serial_number_sorting_icon.png')" alt="" />
          序号
        </div>
        <div :class="['sort-tab-item', currentSortType === 2 ? 'active' : '']" @click="onChangeSortType(2)">
          <img :src="require('@/assets/common/score_sorting_icon.png')" alt="" />
          分数
        </div>
        <div :class="['sort-tab-item', currentSortType === 3 ? 'active' : '']" @click="onChangeSortType(3)">
          <img :src="require('@/assets/common/group_sorting_icon.png')" alt="" />
          小组
        </div>
      </div>
    </div>

    <!-- 集体作答指令按钮（已移至底部栏 PaperAnswerByRollCall，此处不再显示） -->

    <div v-if="showHistory" class="answer-history" @click="checkHistoryAnswer">
      <img class="answer-history-icon" :src="require('@/assets/common/history_blue_icon.png')" alt="" />
      <div class="text">作答历史</div>
    </div>

    <!-- 分组管理弹窗 -->
    <GroupManageDialog
      ref="groupManageDialog"
      :clazz-id="classData && classData.id"
      :student-list="studentList"
      :group-list="groupList"
      @saved="onGroupSaved"
    />
  </div>
</template>

<script>
import { getDTQBindData } from '@/utils/dtq.js'
import { isRunningEnvironment, isRunningInElectron } from '@/utils/electronUtils.js'
import { Grade2ImgSrc, randomNum } from '@/utils/index.js'
import { pinyin } from 'pinyin-pro'
import GroupManageDialog from '@/components/common/GroupManageDialog.vue'
import { getUserGroupByClazz } from '@/api/common'

// 待答名单
export default {
  name: 'WaitingListV2',
  components: {
    GroupManageDialog
  },
  props: {
    // 作答类型--record：录音；operate：选择；written：笔试
    testType: {
      type: String,
      default: () => 'record'
    },
    // 显示/隐藏 作答历史
    showHistory: {
      type: Boolean,
      default: () => false
    },
    // 作答状态 -- wait： 等待；respond：作答中；success：作答完成；recording：录音中；evaluating：评测中
    answerState: {
      type: String,
      default: () => 'wait'
    },
    // 是否作答中
    respond: {
      type: Boolean,
      default: () => false
    },
    // 作答记录列表
    answerData: {
      type: Object,
      default: () => {}
    },
    // 作答模式 SINGLE 单人作答 TEAM 集体作答 ALL 全班作答
    playType: {
      type: String,
      default: () => 'SINGLE'
    },
    studentList: {
      type: Array,
      default: () => []
    },
    // 是否集体作答中
    isTeamAnswering: {
      type: Boolean,
      default: () => false
    },
    // 是否单人答题器作答进行中（下发作答后学生尚未开始录音的窗口期也应禁止切换学生）
    isSingleDtqAnswering: {
      type: Boolean,
      default: () => false
    },
    // 禁用下发作答
    teamAnswerStartBtnDisabled: {
      type: Boolean,
      default: () => false
    },
    changePlayTypeBtnDisabled: {
      type: Boolean,
      default: () => false
    },
    canTeamChangeStudent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortable: {},
      sortStudentList: [],
      popoverVisible: false,
      // 1: 序号, 2: 分数, 3: 小组
      currentSortType: 1,
      sortTypeMap: {
        1: '按默认',
        2: '按得分',
        3: '按作答时间'
      },
      // 置顶学生 id 映射 { [id]: true }
      pinnedIds: {},
      // 小组折叠状态 { [groupId]: true }
      collapsedGroups: {},
      testTypeWaitEnum: {
        record: {
          waitText: '等待录音',
          waitIcon: require('@/assets/common/record.png'),
          disabledWaitIcon: require('@/assets/common/disabled_record.png'),
          respondText: '点击结束录音',
          respondIcon: require('@/assets/common/record.gif')
        },
        operate: {
          waitText: '等待答题',
          waitIcon: require('@/assets/common/wait-answer-blue.png'),
          disabledWaitIcon: require('@/assets/common/wait-answer-blue.png'),
          respondText: '答题中',
          respondIcon: require('@/assets/common/wait-answer-red.png')
        },
        written: {
          correctColor: 'col-1DC060',
          correctText: '答对',
          correctIcon: require('@/assets/common/solid_correct.png'),
          errorColor: 'col-FF3C30',
          errorText: '答错',
          errorIcon: require('@/assets/common/solid_error.png'),
          inaccuracyColor: 'col-FFA516',
          inaccuracyText: '不准确',
          inaccuracyIcon: require('@/assets/common/inaccuracy-yellow.png'),
          respondText: '答题中',
          respondIcon: require('@/assets/common/wait-answer-red.png')
        }
      },
      bindStudentMap: [], // 学生映射表，{学生id: 学生数据}
      studentGroup: {},
      inElectron: isRunningInElectron(),
      environment: isRunningEnvironment(),
      isNoBindDTQ: JSON.parse(sessionStorage.getItem('noBindDTQ')),
      clickerFiltter: false,
      disableTeam: true,
      canActive: true,
      // 分组列表 [{ id, name, students: [] }]
      groupList: []
    }
  },
  computed: {
    sortTypeList() {
      return Object.entries(this.sortTypeMap).map(item => ({ value: Number(item[0]), label: item[1] }))
    },
    classData() {
      return this.$store.getters.classData
    },
    activeAnswer() {
      return this.$store.getters.activeAnswer
    },
    // 小组排序时的分组列表（含未分组学生）
    groupedStudentList() {
      const allStudentIds = new Set(this.sortStudentList.map(s => s.id))
      // 已分组的学生 id 集合
      const groupedIds = new Set()
      const groups = (this.groupList || []).map(g => {
        const students = (g.students || []).filter(s => allStudentIds.has(s.id))
        students.forEach(s => groupedIds.add(s.id))
        return { ...g, students }
      })
      // 未分组学生
      const ungrouped = this.sortStudentList.filter(s => !groupedIds.has(s.id))
      if (ungrouped.length > 0) {
        groups.push({ id: '__ungrouped__', name: '未分组学生', students: ungrouped })
      }
      return groups
    }
  },
  watch: {
    'classData.id'(val, old) {
      if (val && val !== old) {
        this.fetchStudentListByClazzId()
        this.loadGroupList()
      }
    },
    studentList: {
      handler() {
        this.fetchStudentListByClazzId()
      }
    },
    answerData: {
      handler() {
        this.handleSort()
      },
      deep: true
    },
    disableTeam(val, old) {
      if (val && val !== old) {
        // 系统自动切换到单人模式，不补触发下发指令，由用户手动操作
        if (this.playType === 'TEAM') {
          if (this.changePlayTypeBtnDisabled) return // 作答中不切换
          this.$emit('playTypeChange', 'SINGLE', true)
        }
      }
    },
    canActive(val, old) {
      if (!val) {
        setTimeout(() => {
          this.canActive = true
        }, 1000)
      }
    }
  },
  destroyed() {
    this.$store.dispatch('user/setActiveAnswer', null)
    this.$bus.$off('pointerMessage', this.handlePointerMessage)
  },
  created() {
    this.$bus.$on('pointerMessage', this.handlePointerMessage)
  },
  mounted() {
    this.fetchStudentListByClazzId()
    this.loadGroupList()
  },
  methods: {
    Grade2ImgSrc,
    // 切换置顶状态
    togglePin(item) {
      if (this.pinnedIds[item.id]) {
        // 取消置顶：从 pinnedIds 移除，重新按当前排序规则排列
        this.$set(this.pinnedIds, item.id, false)
        // 重新执行排序，让学生回到原来位置
        this.handleSort()
      } else {
        // 置顶
        this.$set(this.pinnedIds, item.id, true)
        this.applyPinSort()
      }
    },
    // 应用置顶排序（置顶学生排最前，其余保持原顺序）
    applyPinSort() {
      const pinned = this.sortStudentList.filter(s => this.pinnedIds[s.id])
      const unpinned = this.sortStudentList.filter(s => !this.pinnedIds[s.id])
      this.sortStudentList = [...pinned, ...unpinned]
    },
    // 点击答题器 icon：切换为单人作答，选中该学生，并下发作答指令
    handleClickerIconClick(item) {
      // 录音中禁止操作
      if (this.answerState === 'respond') return
      // 已提交作答（句子类型练习完成后）禁止操作
      if (this.teamAnswerStartBtnDisabled) return
      // 作答进行中禁止切换模式
      if (this.changePlayTypeBtnDisabled) return
      // 切换为单人作答模式
      if (this.playType !== 'SINGLE') {
        this.$emit('playTypeChange', 'SINGLE')
      }
      // 选中该学生，等 Vuex 更新完再通知父组件下发作答指令
      // 避免 dispatch 异步导致父组件读到旧的 activeStudent
      this.$store.dispatch('user/setActiveAnswer', item)
      this.$nextTick(() => {
        this.$emit('startSingleAnswer')
      })
    },
    // 无答题器时点击录音 icon：选中学生并开始录音
    selectAndRecord(item) {
      // 录音中禁止操作
      if (this.answerState === 'respond') return
      // 已提交作答（句子类型练习完成后）禁止操作
      if (this.teamAnswerStartBtnDisabled) return
      this.$store.dispatch('user/setActiveAnswer', item)
      this.$nextTick(() => {
        this.$emit('startRespond')
      })
    },
    // 切换分组展开/收起
    toggleGroup(groupId) {
      this.$set(this.collapsedGroups, groupId, !this.collapsedGroups[groupId])
    },
    // 计算分组平均分（用于显示），无得分返回 null
    getGroupAvgScore(group) {
      const scores = (group.students || [])
        .map(s => this.answerData[s.id]?.result?.overall)
        .filter(v => typeof v === 'number')
      if (scores.length === 0) return null
      return scores.reduce((a, b) => a + b, 0) / scores.length
    },
    // 计算分组平均得分率（用于颜色判断），无得分返回 null
    getGroupAvgScoreRate(group) {
      const rates = (group.students || [])
        .map(s => this.answerData[s.id]?.result?.scoreRate)
        .filter(v => typeof v === 'number')
      if (rates.length === 0) return null
      return rates.reduce((a, b) => a + b, 0) / rates.length
    },
    // 根据得分率返回颜色 class
    getScoreColor(scoreRate) {
      if (scoreRate === null) return ''
      if (scoreRate < 60) return 'col-FF3C30'
      if (scoreRate < 85) return 'col-FFA516'
      return 'col-1DC060'
    },
    onChangeSortType(value) {
      this.currentSortType = value
      this.handleSort()
      this.popoverVisible = false
    },
    handleSort() {
      const sortHandlerMap = {
        1: () => {
          this.sortStudentList = this.$_.cloneDeep(this.studentList)
        },
        2: () => {
          // 先从原始列表重置，保留无分数学生的原始相对顺序
          const base = this.$_.cloneDeep(this.studentList)
          this.sortStudentList = base.sort((a, b) => {
            const aScore =
              typeof this.answerData[a.id]?.result?.overall === 'number'
                ? Number(Number(this.answerData[a.id]?.result?.overall).toFixed(2))
                : -1
            const bScore =
              typeof this.answerData[b.id]?.result?.overall === 'number'
                ? Number(Number(this.answerData[b.id]?.result?.overall).toFixed(2))
                : -1
            // 两者都无分数时，保持原始顺序（stable sort 依赖 base 已按原始顺序排列）
            if (aScore === -1 && bScore === -1) return 0
            return bScore - aScore
          })
        },
        3: () => {
          // 小组排序：sortStudentList 保持默认顺序，分组由 groupedStudentList computed 处理
          this.sortStudentList = this.$_.cloneDeep(this.studentList)
          // 初始化所有分组为收起状态
          const collapsed = {}
          this.groupedStudentList.forEach(g => {
            collapsed[g.id] = true
          })
          this.collapsedGroups = collapsed
        }
      }
      sortHandlerMap[this.currentSortType]()
      // 重新应用置顶
      this.applyPinSort()
    },
    // 查看作答历史
    checkHistoryAnswer() {
      this.$emit('checkHistoryAnswer')
    },
    // 获取班级的学生列表
    async fetchStudentListByClazzId() {
      let bindStudentList = []
      const bindStudentMap = {}
      if (this.inElectron) {
        bindStudentList = await getDTQBindData(this.classData.id)
        //console.log('绑定答题器的学生', bindStudentList)
        bindStudentList
          ?.filter(el => el.isBindAnswerDevice)
          .forEach(el => {
            bindStudentMap[el.id] = el
          })
      }
      this.bindStudentMap = { ...bindStudentMap }
      this.processingStudentList()
    },
    // 处理学生名单
    processingStudentList() {
      const obj = {}
      const list = this.studentList || []
      const map = this.bindStudentMap
      list.forEach(el => {
        const hasBind = !!map[el.id]
        el.isBindAnswerDevice = !!map[el.id]
        el.answerDeviceId = map[el.id]?.answerDeviceInfo?.answerDeviceId || 0
        el.answerDeviceInfo = map[el.id]?.answerDeviceInfo || {}
        const name = el['realName'] || el['loginAccount'] || el['name']
        const initialLetter = pinyin(name?.split('')[0], {
          pattern: 'first',
          toneType: 'none',
          mode: 'surname'
        }).toUpperCase()
        const letterAsCII = initialLetter.charCodeAt()
        el.initialLetter = initialLetter
        el.initialLetterAsCII = letterAsCII
        if (obj[initialLetter]) {
          obj[initialLetter].studentList.push(el)
        } else {
          obj[initialLetter] = {
            key: initialLetter,
            id: letterAsCII,
            studentList: [el]
          }
        }
        obj[initialLetter].hasBind = obj[initialLetter].hasBind || hasBind
      })
      this.sortStudentList = this.$_.cloneDeep(list)
      this.handleSort()
      this.disableTeam = !list?.find(el => el.isBindAnswerDevice)
      this.studentGroup = Object.keys(obj)
        .map(key => obj[key])
        .sort((a, b) => {
          return a.id - b.id
        })
      this.$nextTick(() => {
        if (this.activeAnswer) {
          const index = list.findIndex(el => {
            return el.id === this.activeAnswer.id
          })
          if (index !== -1) {
            this.autoScroll(list[index])
          }
        }
      })
    },
    // 是否过滤答题器变更
    changeFiltter() {
      if (this.answerState === 'respond' && this.testType !== 'written') {
        if (!this.clickerFiltter && !this.activeAnswer.isBindAnswerDevice) {
          this.$message.warn('该学生作答中禁止隐藏')
          return
        }
      }
      this.clickerFiltter = !this.clickerFiltter
    },
    // 指定滚动的容器
    getContainer() {
      return this.$refs.waitingContent
    },
    // 获取得分星星数量
    fetchStarNum(scoreRate) {
      scoreRate = Number(scoreRate)
      if (scoreRate >= 80) {
        return 5
      } else if (scoreRate >= 60) {
        return 4
      } else if (scoreRate >= 40) {
        return 3
      } else if (scoreRate >= 20) {
        return 2
      } else {
        return 1
      }
    },
    // 自动滚动处理
    autoScroll(data) {
      const ctx = document.getElementById(data.initialLetter)
      const ctx2 = document.getElementById(data.id)
      if (!ctx || !ctx2) return
      // 可显示区域的高度
      const usableHeight = window.innerHeight - 218
      // 选中区块到分组头部的距离
      const scrollHeight = ctx2.offsetTop - ctx.offsetTop + 50
      // 分组滚动到顶部所需的距离
      let needScrollHeight = ctx.offsetTop - 50
      // 如果分组滚动到顶部后，不能完整显示选中区块
      if (scrollHeight > usableHeight) {
        needScrollHeight = ctx2.offsetTop - usableHeight / 2
      }
      this.$refs.waitingContent.scrollTop = needScrollHeight
    },
    // 变更作答学生
    changeAnswer(data) {
      // 下发作答过程中不能切换学生（集体作答 或 单人答题器已下发）
      if (this.isTeamAnswering || this.isSingleDtqAnswering) return
      if (this.answerState === 'respond' && this.testType !== 'written') return
      // 有学生绑定答题器时，未绑定答题器的学生不可被选中
      if (!this.disableTeam && !data.isBindAnswerDevice) return
      // 如果选中了的话，取消选中
      if (this.activeAnswer && this.activeAnswer.id === data.id) {
        this.$store.dispatch('user/setActiveAnswer', null)
        // 有学生绑定答题器时，取消选中需将作答模式切回集体作答
        if (!this.disableTeam) {
          if (this.changePlayTypeBtnDisabled) return
          this.$emit('playTypeChange', 'TEAM', true)
        }
      } else {
        // 有学生绑定答题器且当前是集体作答，切换为单人作答
        if (!this.disableTeam && this.playType === 'TEAM') {
          if (this.changePlayTypeBtnDisabled) return
          this.$emit('playTypeChange', 'SINGLE')
        }
        // 直接选中学生，不自动下发作答指令（由用户点击答题器 icon 或底部按钮显式触发）
        this.$store.dispatch('user/setActiveAnswer', data)
      }
    },
    // 开始/结束录音
    startRespond() {
      if (this.activeAnswer && this.activeAnswer.isBindAnswerDevice) return
      this.$emit('startRespond')
    },
    // 查看评测结果
    checkAnswer(data, student) {
      this.$emit('checkAnswer', data, student)
    },
    // // 清除代答名单中的某个学生
    // remove(index) {
    //   this.waitingList.splice(index, 1)
    //   this.$store.dispatch('user/setWaitingList', this.waitingList)
    //   this.$store.dispatch('user/setActiveAnswer', this.waitingList?.length ? this.waitingList[0] : null)
    // },
    // // 清空名单
    // removeList() {
    //   const that = this
    //   this.$confirm({
    //     title: '温馨提示',
    //     content: '是否确认清空待答名单',
    //     okText: '确认',
    //     okType: 'danger',
    //     cancelText: '取消',
    //     onOk() {
    //       that.waitingList = []
    //       that.$store.dispatch('user/setActiveAnswer', null)
    //       that.$store.dispatch('user/setWaitingList', [])
    //     },
    //     onCancel() {
    //     }
    //   })
    // },
    // // 打开点名弹框
    // openRollCallDialog() {
    //   this.$emit('openRollCallDialog')
    // }
    handlePointerMessage(data) {
      switch (data.ans_str) {
        case 'D':
          if (data.key_event === 'double') {
            if (this.changePlayTypeBtnDisabled) return
            if (this.playType === 'SINGLE') {
              if (this.answerState === 'respond' && this.testType !== 'written') return
              this.$emit('playTypeChange', 'TEAM')
            } else {
              if (this.isTeamAnswering) return
              this.$emit('playTypeChange', 'SINGLE')
            }
          } else {
            if (this.playType === 'SINGLE') {
              this.randomRollCall()
            } else {
              if (!this.isTeamAnswering) {
                this.startAnswer()
              } else {
                this.endAnswer()
              }
            }
          }
          break
        case 'C':
          if (this.playType === 'TEAM') {
            if (this.isTeamAnswering) {
              this.endAnswer()
            } else {
              this.startAnswer()
            }
          } else if (this.playType === 'SINGLE') {
            if (data.key_event === 'double') {
              if (this.activeAnswer) this.changeAnswer(this.activeAnswer)
            }
          }
          break
        default:
          break
      }
    },
    // 随机点名（单人作答）
    randomRollCall() {
      if (this.answerState === 'respond' && this.testType !== 'written') return
      // 没有名单直接返回
      if (!this.studentList || this.studentList.length <= 0) {
        return
      }
      // 获取随机索引
      let randomStudentList = JSON.parse(JSON.stringify(this.studentList))
      // 如果当前用户已被点名，则需要绕过
      if (this.activeAnswer && this.activeAnswer.id) {
        randomStudentList = randomStudentList.filter(student => student.id !== this.activeAnswer.id)
      }
      // 只显示绑定答题器学生，过滤未绑定答题器学生
      if (this.clickerFiltter) {
        randomStudentList = randomStudentList.filter(student => student.isBindAnswerDevice)
      }
      // 没有名单直接返回
      if (randomStudentList.length <= 0) {
        return
      }
      // 获取随机数
      let studentIndex = randomNum(0, randomStudentList.length)

      // 找到该学生在完整列表中的位置
      const student = randomStudentList[studentIndex]
      for (let i = 0; i < this.studentList.length; i++) {
        if (student.id === this.studentList[i].id) {
          studentIndex = i
          break
        }
      }
      this.changeAnswer(this.studentList[studentIndex])
      this.autoScroll(this.studentList[studentIndex])
    },
    // 集体作答(开始做答)
    startAnswer() {
      if (this.teamAnswerStartBtnDisabled) return
      if (!this.canActive) {
        return
      } else {
        this.canActive = false
      }
      this.$emit('teamAnswerStart')
    },
    // 集体作答（结束作答）
    endAnswer() {
      if (!this.canActive) {
        return
      } else {
        this.canActive = false
      }
      this.$emit('teamAnswerEnd')
    },
    // 编辑分组
    handleEditGroup(group) {
      this.$refs.groupManageDialog.open(group.id)
      this.$emit('editGroup')
    },

    // 加载分组数据
    loadGroupList() {
      if (!this.classData || !this.classData.id) return
      getUserGroupByClazz({ clazzId: this.classData.id, userId: this.$store.getters.userId }).then(res => {
        const { state, data } = res
        if (state !== 11) return
        // 将接口返回的 userList 映射为 students，并用 studentList 中的完整学生对象填充
        const studentMap = {}
        this.studentList.forEach(stu => {
          studentMap[stu.id] = stu
        })
        this.groupList = (data || []).map(group => ({
          ...group,
          students: (group.userList || []).map(u => studentMap[u.id] || u)
        }))
      })
    },
    // 分组保存成功后的回调
    onGroupSaved() {
      this.loadGroupList()
    }
  }
}
</script>

<style lang="scss" scoped>
.waiting-list {
  height: 100%;

  .group-anchor {
    position: absolute;
    top: 50px;
    right: 0;
    width: 34px;
    height: calc(100% - 114px);
    //height: 100%;
    background-color: #ffffff;
    border-radius: 16px 0 0 16px;
    padding: 8px 0;

    .group-anchor-item {
      width: 28px;
      //height: 21px;
      font-size: 12px;
      line-height: 17px;
    }
  }

  .waiting-title {
    height: 50px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 50px;
    padding: 0 14px 0 20px;
    border-bottom: 1px solid #f1f1f1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .waiting-title-left {
      display: flex;
      align-items: center;
    }

    .waiting-title-right {
      .sort-btn {
        height: auto;
        line-height: 20px;
        font-size: 16px;
        font-weight: initial;
        cursor: pointer;
      }
    }

    .waiting-icon-box {
      width: 34px;
      height: 28px;
      background: #f1f1f1;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 4px;

      .icon {
        width: 20px;
        height: 20px;
      }
    }

    .clicker-filtter {
      width: 32px;
      height: 28px;
      margin-left: 4px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f1f1f1 url('@/assets/test/clicker_unactive.png') no-repeat center center;
      background-size: 20px 20px;
      cursor: pointer;

      &.active {
        background-color: #e8f1ff;
        background-image: url('@/assets/test/clicker_active.png');
      }

      &:hover {
        background-image: url('@/assets/test/clicker_active.png');
      }
    }
  }

  .waiting-content {
    height: calc(100% - 160px);
    overflow-y: scroll;
    padding-bottom: 12px;

    .group-item {
      height: 32px;
      color: #999999;
      font-size: 14px;
      line-height: 20px;
      padding: 6px 20px;
      border-bottom: 1px solid #f1f1f1;
    }

    .waiting-item {
      height: 50px;
      line-height: 20px;
      padding: 0 14px 0 8px;
      border-bottom: 1px solid #f1f1f1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      // 左侧：置顶icon + 名字
      .waiting-item-left {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;
        overflow: hidden;
      }

      // 置顶 icon
      .pin-icon {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 4px;
        opacity: 0.5;

        &:hover,
        &.pinned {
          opacity: 1;
        }
      }

      // 无答题器录音 icon（内联在名字后面）
      .record-inline-icon {
        vertical-align: middle;
        margin-left: 4px;
        cursor: pointer;
        flex-shrink: 0;

        &.disabled {
          cursor: not-allowed;
        }
      }

      // 答题器 icon（内联在名字后面）
      .clicker-inline-icon {
        vertical-align: middle;
        margin-left: 4px;
        cursor: pointer;
        flex-shrink: 0;

        &.disabled {
          cursor: not-allowed;
        }
      }

      &.waiting-answer {
        background: linear-gradient(90deg, #f9fbff 0%, #d1e4ff 100%);
        color: #1976ff !important;
      }

      &.recording-answer {
        background: linear-gradient(90deg, #fff9f9 0%, #fedbd8 100%);
        color: #ff3c30 !important;
      }

      .waiting-item-name {
        font-size: 17px;
        font-weight: 400;
        color: #333333;
      }

      .waiting-item-state {
        background: rgba(255, 255, 255, 0.8);
        border-radius: 100px 6px 6px 100px;
        display: flex;
        padding: 5px 5px 5px 8px;
        margin-right: 5px;

        .item-state-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }

        .evaluating-icon-box {
          width: 16px;
          height: 16px;
          margin-right: 5px;
          font-size: 0;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);

          .item-state-icon {
            width: 11px;
            height: 11px;
            margin-right: 0;
          }
        }

        .item-state-text {
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
        }
      }

      .waiting-item-content {
        min-width: 82px;
        height: 26px;
        border-radius: 13px 6px 6px 13px;
        margin-right: 5px;
        display: flex;
        align-items: center;
        //justify-content: space-between;
        background-color: #ffffff;
        padding: 5px 5px 5px 8px;

        .wait-record-icon {
          width: 16px;
          height: 16px;
        }

        .waiting-item-text {
          font-size: 12px;
          line-height: 16px;
          color: #1976ff;
          margin-left: 5px;

          &.recording {
            color: #ff3c30;
          }
        }
      }

      .waiting-item-answer {
        height: 36px;
        display: flex;
        align-items: center;

        .answer-score {
          text-align: center;
          height: 22px;
          font-size: 16px;
          line-height: 22px;
        }

        .answer-star {
          height: 14px;
          display: flex;

          .answer-star-img {
            width: 14px;
            height: 14px;
          }
        }

        .arrow-right-icon {
          width: 4px;
          height: 7px;
          margin-left: 6px;
        }
      }

      .written-answer {
        height: 24px;
        padding: 4px 5px;
        display: flex;
        align-items: center;

        .written-answer-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }

        .written-answer-text {
          font-size: 12px;
          line-height: 24px;
        }
      }

      .sort-icon,
      .close-icon {
        width: 16px;
        height: 16px;
      }

      .close-icon {
        margin-left: 17px;
      }

      &:hover {
        background: linear-gradient(90deg, #fafafa 0%, #f1f1f1 100%);

        .name {
          font-weight: 600;
        }
      }

      &.active {
        background: linear-gradient(90deg, #f9fbff 0%, #d1e4ff 100%);

        &.respond {
          background: linear-gradient(90deg, #fff9f9 0%, #fedbd8 100%);
        }

        .name {
          color: #1976ff;
          font-weight: 600;
        }
      }
    }

    .empty-box {
      height: 100%;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;

      .empty-message {
        font-size: 20px;
        line-height: 28px;
        color: #333333;
        margin-top: 20px;
      }

      .empty-remark {
        font-size: 13px;
        line-height: 18px;
        color: #999999;
        margin-top: 10px;
      }
    }
  }

  // 底部排序 tab 样式
  .sort-tab-bar {
    padding: 10px 16px 0;
  }

  .sort-tab-group {
    border-radius: 8px;
    height: 38px;
    display: flex;
    align-items: center;
    padding: 3px;
    background: #f6f6f6;

    .sort-tab-item {
      flex: 1;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
      transition: background-color 0.15s;

      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }

      &.active {
        background-color: #ffffff;
        border-radius: 6px;
      }

      &:hover:not(.active) {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  // 分组 header 样式
  .group-header {
    height: 50px;
    padding: 0 14px 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(270deg, rgba(246, 246, 246, 1) 0%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 1px solid #f1f1f1;
    cursor: pointer;

    .group-header-left {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
    }

    .group-collapse-icon {
      margin-right: 4px;
      width: 11px;
      height: 6px;
      flex-shrink: 0;
    }

    .group-header-name {
      font-size: 17px;
      font-weight: 600;
      color: #333333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 10px;
    }

    .group-edit-icon {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 4px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        background: #e8f1ff;
      }
    }

    .group-avg-score {
      font-size: 16px;
      font-weight: 500;
      flex-shrink: 0;
      margin-left: 8px;
    }
  }

  .answer-mode {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 51px 0 51px;
    background: linear-gradient(270deg, #f6f6f6 0%, #e8f1ff 100%);
    border-radius: 18px 18px 0 0;
    cursor: default;

    &.disable {
      background: #f6f6f6;

      .text {
        color: #c8c8c8;
      }
    }

    .mode-left-icon {
      width: 14px;
      height: 14px;
    }

    .text {
      font-size: 14px;
      font-weight: 400;
      color: #1976ff;
      line-height: 20px;
      margin: 0 4px;
    }

    .mode-right-icon {
      width: 10px;
      height: 10px;
    }
  }

  .answer-history {
    margin: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    cursor: pointer;
    height: 38px;
    background: linear-gradient(270deg, #e8f1ff 0%, #f6f6f6 100%);
    border-radius: 19px;

    .answer-history-icon {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }

    .text {
      font-size: 14px;
      font-weight: 400;
      color: #1976ff;
      line-height: 20px;
    }

    &:hover {
      background: #e8f1ff;
    }
  }
}

::v-deep .ant-anchor-wrapper {
  //background-color: #1DC060;
  width: 34px;
  height: 100%;
  margin-left: 0;
  padding-left: 0;

  .ant-anchor {
    .ant-anchor-ink {
      display: none;
    }

    .ant-anchor-link {
      &.group-anchor-item {
        display: block;
        width: 28px;
        height: 21px;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        padding: 0;

        &:hover {
          background-color: #e8f1ff;
          color: #1976ff;

          .ant-anchor-link-title {
            color: #1976ff;
          }
        }

        &.ant-anchor-link-active {
          & > .ant-anchor-link-title {
            color: #1976ff;
          }
        }

        .ant-anchor-link-title {
          color: #333333;
        }
      }
    }
  }
}

::v-deep .sort-type-popover {
  .ant-popover-inner-content {
    padding: 5px 0;

    .sort-type-item {
      padding: 5px 8px;
      cursor: pointer;

      &.active {
        background: #1976ff;
        color: #ffffff;
      }
    }
  }
}

.col-1DC060 {
  color: #1dc060 !important;
}

.col-FFA516 {
  color: #ffa516 !important;
}

.col-FF3C30 {
  color: #ff3c30 !important;
}

.score-img {
  width: 22px;
  height: 22px;
}
</style>
